module.exports = __webpack_public_path__ + "static/media/Logo_WHT_SVG-01.6c5d9ae9.svg";